<template>
  <v-navigation-drawer
    app
    temporary
    v-model="drawer"
    
    :right="!$vuetify.rtl"
    style="direction: ltr"
    class="grey lighten-4"
  >
    <v-list class="pt-0" style="height: 100%">
      <div
        class="flex-column fill-height text-xs-center py-4 pb-4 pl-2 v-middle"
      >
        <a
          href="https://behsazanpoya.com"
          target="_blank"
          class="bp_dark--text"
        >
          <bp-logo></bp-logo>
          <h1 class="mt-3 font-weight-bold">
            <span style="letter-spacing: 0.2em">Mehran </span>
            <span class="bp_green--text">Sarwari</span>
          </h1>
          <h4 class="text-md-h5" style="letter-spacing: 0.09em !important">
            TECHNOLOGY SERVICES
          </h4>
        </a>
        <v-divider style="flex: 1; width: 80%" class="my-2"></v-divider>
        <a
          href="mailto:info@behsazanpoya.com"
          class="subheading bp_dark--text"
          style="letter-spacing: 0.1em !important"
        >
          info@mehransarwari.com
        </a>
        <span class="body-1" style="letter-spacing: 0.125em !important">
          <a href="tel:+9378833358" class="bp_dark--text">078833358</a> -
          <a href="tel:+93797103103" class="bp_dark--text">0797103103</a>
          <br>
          <a href="tel:+33766805828" class="bp_dark--text">+33 766805828</a>
        </span>
        <v-btn
          class="py-2 px-5 mt-5"
          depressed
          dark
          color="bp_dark"
          @click="logout"
        >
          <v-icon v-html="'logout'" />
          <span class="mx-2"> {{ $t("logout") }}</span>
        </v-btn>
      </div>
      <v-footer
        fixed
        height="3"
        class="di-flex font-weight-medium justify-center"
      >
        <div class="text-xs-center">&copy; 2021 MS. All rights reserved</div>
      </v-footer>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: ["appDrawer"],

  data: () => ({
    logo: require("../assets/images/bplogo_dark.svg"),
  }),

  computed: {
    drawer: {
      get: ({ appDrawer }) => appDrawer,
      set(val) {
        this.$emit("update:appDrawer", val);
      },
    },
  },
  methods: {
    logout() {
      let clear = () => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("currentUser");
        this.$store.commit("AuthModule/setToken", false);
        delete this.axios.defaults.headers.common["Authorization"];
        this.$router.replace("/auth/login");
        // window.location.reload();
      };
      this.axios.post("logout").then(clear()).catch(clear());
    },
  },
};
</script>